import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ClientReviewResponse, WidgetCommonLayoutConfiguration } from '@vestico/model';

import { UserContext } from '@vestico/shared';

import { generatePreviewText } from '../model/previewText';

export const usePreviewTexts = (layout: WidgetCommonLayoutConfiguration, responses: ClientReviewResponse[]) => {
  const { t, i18n } = useTranslation('shared');
  const { user } = useContext(UserContext);

  const { showPreviewText } = layout;

  const responsePreviewTexts = useMemo(() => {
    if (!showPreviewText) {
      return [];
    }

    const previewTexts = responses.map((response) => {
      const tt = generatePreviewText(response, user, t, i18n.language);

      return tt;
    });

    return previewTexts;
  }, [i18n.language, responses, showPreviewText, t, user]);

  return responsePreviewTexts;
};
